import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Redirect } from 'react-router-dom';

import {
  Page,
  TodoList,
  DealSourceLink,
  LinkDealToSource,
  CurrencyTip,
  DealCloseDate,
} from '../../shared';

import ReactTooltip from 'react-tooltip';

import {
  UpdateDealModal,
  LinkSalesforceDealModal,
  TrackImperativeTaskModal,
  TrackFunnelTaskModal,
  DealActivityModal,
} from '../../modals';

import { getIcon } from '../../../util/icons';
import {
  getSevenImperative,
  getSevenImperatives,
  getImperativesStages
} from '../../../util/data';

import {
  isDevelopment,
  formatThousands,
  generateUnsafeHash,
  getCurrentTime,
  getDealCompletion,
  getClassModifierForConfidence,
  dealAmountAsString,
  getTaskUpdateForStatus,
} from '../../../util';

import {
  fetchDeal,
  fetchDealsForEmployee,
  updateDeal,
} from '../../../actions/deals';

import {
  syncSalesforceDeal
} from '../../../actions/integrations/salesforce';

import { MessageModal } from '../../modals';

import KeyRisks from './keyRisks';
import ActionItems from './actionItems';

class ImperativesDealPage extends Component {

  state = {
    syncingDeal: false,
    pageMessage: null,
    updatingDeal: false,
    viewingDealActivity: false,
    verifyingDeal: false,
    linkingDeal: false,
    redirectingToDeal: false,
    expandedImperatives: {
      //none to start
    },
    expandedStages: {},
    trackingImperativeTask: null,
    syncingImperativeTask: false,
    trackingFunnelTask: null,
    syncingFunnelTask: false,
    imperativeSummaries: {
      '1': '', '2': '', '3': '', '4': '', '5': '', '6': '', '7': ''
    },
    syncingImperativeSummary: null,
    viewingImperativeDiscoveryQuestions: null,
  }

  expandStagesBasedOnCurrentProgress(){
    const expandedStages = {};

    const currentDealStage = (this.props.deal || {}).stage || false;

    _.each(this.dealStages(), (stage, stageIndex) => {
      if(stage.value === currentDealStage){
        expandedStages[stage.value] = true;
      }
      else if(stageIndex === 0){
        expandedStages[stage.value] = this.getStageStatus(stage.value) !== 'complete';
      }
      else{
        expandedStages[stage.value] = this.getStageStatus(stage.value) === 'in_progress';
      }
    });

    this.setState({
      expandedStages,
    });
  }

  mapDealToState(deal){
    this.setState({
      syncingDeal: false,
      imperativeSummaries: {
        ...deal.imperativeSummaries
      }
    }, () => {
      this.expandStagesBasedOnCurrentProgress();
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot){

    const { match: { params } } = this.props;

    if(prevProps.deal && prevProps.deal._id !== params.dealId && !this.props.loadingDeal){
      this.props.fetchDeal(params.dealId, this.mapDealToState.bind(this));
      this.setState({
        redirectingToDeal: false,
      });
    }

    if(!prevProps.organization && this.props.organization && this.props.organization.dealStages){
      //need to recalculate expanded stages
      this.expandStagesBasedOnCurrentProgress();
    }
  }

  componentWillMount(){

    const { match: { params } } = this.props;

    let employeeId = params.employeeId;
    const dealId = params.dealId;

    //if no employeeId...user accessing sprint
    //TODO figure out a better way of managing this
    if(employeeId){
      this.setState({
        employeeId,
        isOwnDeals: false,
      })
    }
    else{
      employeeId = this.props.user.uid;

      this.setState({
        employeeId,
        isOwnDeals: true,
      });
    }

    this.props.fetchDeal(dealId, this.mapDealToState.bind(this));

    //also fetch deals if unloaded (for nav menu)
    if(!this.props.deals){
      this.props.fetchDealsForEmployee(employeeId);
    }
  }

  beginLinkingDeal(){
    this.setState({
      linkingDeal: true
    });
  }
  afterDealLink(deal){
    this.setState({
      redirectingToDeal: deal._id,
      linkingDeal: false,
    });
  }

  updateImperativeTaskStatus(id, newStatus){

    if(this.state.syncingImperativeTask === id){
      return;
    }
    this.setState({
      syncingImperativeTask: id
    });

    let dealToSave = { ...this.props.deal };

    dealToSave.imperativeTasks = {
      ...dealToSave.imperativeTasks,
      [id]: getTaskUpdateForStatus(newStatus)
    }

    this.props.updateDeal(dealToSave, updatedDeal => {
      this.setState({
        syncingImperativeTask: null,
        trackingImperativeTask: null
      });
    });
  }

  renderTrackImperativeTaskModal(){

    const { trackingImperativeTask, syncingImperativeTask } = this.state;

    if(!trackingImperativeTask){
      return null;
    }

    return <TrackImperativeTaskModal
      imperativeName={getSevenImperative(trackingImperativeTask.imperative).name}
      imperativeTask={trackingImperativeTask}
      hide={() => { this.setState({ trackingImperativeTask: null }); }}
      updateStatus={newStatus => { this.updateImperativeTaskStatus(trackingImperativeTask.id, newStatus); }}
      syncingImperativeTask={syncingImperativeTask}
      currentTaskStatus={this.getImperativeTaskStatus(trackingImperativeTask.id)}
    />
  }
  trackImperativeTask(imperativeTask){
    this.setState({
      trackingImperativeTask: imperativeTask
    });
  }

  updateFunnelTaskStatus(id, newStatus){

    if(this.state.syncingFunnelTask === id){
      return;
    }
    this.setState({
      syncingFunnelTask: id
    });

    let dealToSave = { ...this.props.deal };

    dealToSave.funnelTasks = {
      ...dealToSave.funnelTasks,
      [id]: getTaskUpdateForStatus(newStatus)
    }

    //contract signed - deal is now won
    if(id === '118' && newStatus == 'complete'){
      dealToSave.status = 'won';
    }
    //contract was signed, now marked not signed, deal goes to open
    else if(id === '118' && newStatus != 'complete'){
      if(dealToSave.status === 'won'){
        dealToSave.status = 'open';
      }
    }

    this.props.updateDeal(dealToSave, updatedDeal => {
      this.setState({
        syncingFunnelTask: null,
        trackingFunnelTask: null
      });
    });
  }

  getImperativeTask(id){
    const allImperativeItems = _.flatMap(getSevenImperatives(), 'tasks');

    return _.find(allImperativeItems, { id }) || null;
  }

  renderTrackFunnelTaskModal(){
    const { trackingFunnelTask, syncingFunnelTask } = this.state;

    if(!trackingFunnelTask){
      return null;
    }

    return <TrackFunnelTaskModal
      funnelTask={trackingFunnelTask}
      hide={() => { this.setState({ trackingFunnelTask: null }); }}
      updateStatus={newStatus => { this.updateFunnelTaskStatus(trackingFunnelTask.id, newStatus); }}
      syncingFunnelTask={syncingFunnelTask}
      currentTaskStatus={this.getFunnelTaskStatus(trackingFunnelTask)}
    />
  }
  trackFunnelTask(funnelTask){
    if(funnelTask.imperativeId){
      this.expandImperative(funnelTask.imperativeId, true);
    }
    else if(funnelTask.imperativeTaskId){
      this.trackImperativeTask(this.getImperativeTask(funnelTask.imperativeTaskId));
    }
    else{
      this.setState({
        trackingFunnelTask: funnelTask
      });
    }
  }
  quickCompleteFunnelTask(funnelTask){
    if(funnelTask.imperativeId){
      this.expandImperative(funnelTask.imperativeId, true);
    }
    else if(funnelTask.imperativeTaskId){
      this.updateImperativeTaskStatus(funnelTask.imperativeTaskId, 'complete');
    }
    else{
      this.updateFunnelTaskStatus(funnelTask.id, 'complete');
    }
  }

  expandImperative(imperativeId, onlyExpand = false){
    this.setState({
      expandedImperatives: {
        ...this.state.expandedImperatives,
        [imperativeId]: !this.state.expandedImperatives[imperativeId] || onlyExpand
      }
    });
  }

  expandStage(stageId){
    this.setState({
      expandedStages: {
        ...this.state.expandedStages,
        [stageId]: !this.state.expandedStages[stageId]
      }
    });
  }

  getImperativeTaskStatus(id){
    const item = (this.props.deal.imperativeTasks || {})[id];

    //old version of tracking statuses just used the status name instead of an object with a status property, handle both cases here
    const status = item && item.status || item;

    if(status === 'complete'){
      return 'complete';
    }
    else if(status === 'failed'){
      return 'failed';
    }
    else{
      return 'incomplete';
    }
  }
  getImperativeStatus(id){
    //let hasFailedTask = false;
    let allTasksComplete = true;

    // console.log('checking imperative status: ', id);

    _.each(getSevenImperative(id).tasks, task => {
      const taskStatus = this.getImperativeTaskStatus(task.id);
      // console.log(`subtask [${task.id}]: ${taskStatus}`);
      if(taskStatus !== 'complete'){
        //hasFailedTask = true;
        allTasksComplete = false;
      }
    });

    return allTasksComplete ? 'complete' : 'incomplete';
  }
  getFunnelTaskStatus(funnelTask){
    if(!this.props.deal){
      return 'incomplete';
    }
    else if(funnelTask.imperativeId){
      //check if imperative is complete
      return this.getImperativeStatus(funnelTask.imperativeId);
    }
    else if(funnelTask.imperativeTaskId){
      //check if imperative item is complte
      return this.getImperativeTaskStatus(funnelTask.imperativeTaskId)
    }
    else{
      const item = (this.props.deal.funnelTasks || {})[funnelTask.id];

      //old version of tracking statuses just used the status name instead of an object with a status property, handle both cases here
      const status = item && item.status || item;

      if(status === 'complete'){
        return 'complete';
      }
      else if(status === 'failed'){
        return 'failed';
      }
      else{
        return 'incomplete';
      }
    }
  }

  localImperativeSummary(id){
    const item = this.state.imperativeSummaries[id];

    return item || '';
  }
  serverImperativeSummary(id){
    const item = (this.props.deal.imperativeSummaries || {})[id];

    return item || '';
  }
  imperativeSummaryIsDirty(id){
    return this.localImperativeSummary(id) !== this.serverImperativeSummary(id);
  }

  renderImperativeTask(imperativeTask){
    const { id, text, imperative } = imperativeTask;

    const itemStatus = this.getImperativeTaskStatus(id);

    const isComplete = itemStatus === 'complete';
    const isFail = itemStatus === 'failed';
    const isIncomplete = itemStatus === 'incomplete';

    return (
      <li
        onClick={(e) => { e.stopPropagation(); this.trackImperativeTask(imperativeTask); return false; }}
        key={id}
        className={`imperative-item ${itemStatus}`}
      >
        <div className="imperative-item-text">{text}</div>
        <div
          onClick={(e) => { if(isIncomplete){ e.stopPropagation(); this.updateImperativeTaskStatus(id, 'complete'); return false; }  }}
          className="imperative-item-check">{isComplete ? getIcon('check-fill') : (isFail ? getIcon('check-fail') : getIcon('check-empty'))}</div>
      </li>
    );
  }

  updateLocalImperativeSummary(id, newSummary){
    this.setState({
      imperativeSummaries: {
        ...this.state.imperativeSummaries,
        [id]: newSummary
      }
    });
  }

  saveImperativeSummaryChanges(id){
    if(this.state.syncingImperativeSummary === id){
      return;
    }
    this.setState({
      syncingImperativeSummary: id
    });

    let dealToSave = { ...this.props.deal };

    dealToSave.imperativeSummaries = {
      ...dealToSave.imperativeSummaries,
      [id]: this.localImperativeSummary(id)
    }

    this.props.updateDeal(dealToSave, updatedDeal => {
      this.setState({
        syncingImperativeSummary: null,
      });
    });
  }

  handleQuickSummaryKeyDown(e, id){

    const modifierKeyPressed = e.ctrlKey || e.altKey || e.shiftKey || e.metaKey;

    if(e.key === 'Escape'){
      e.preventDefault();
      this.setState({
        imperativeSummaries: {
          ...this.state.imperativeSummaries,
          ...this.props.deal.imperativeSummaries,
        }
      });
    }
    if(e.key === 'Enter' && modifierKeyPressed){
      e.preventDefault();
      this.saveImperativeSummaryChanges(id);
    }
  }

  viewDiscoveryQuestions(imperative){
    this.setState({
      viewingImperativeDiscoveryQuestions: imperative
    });
  }

  renderImperative(imperative){

    const { expandedImperatives } = this.state;

    const { name, id, summaryQuestion, tasks, questions } = imperative;

    const summary = this.localImperativeSummary(id);

    const imperativeTasksComplete = _.reduce(tasks, (memo, task) => {
      return memo + (this.getImperativeTaskStatus(task.id) === 'complete' ? 1 : 0);
    }, 0);

    return (
      <div
        onClick={() => { this.expandImperative(id); }}
        key={id}
        className={`imperative imperative-${id} ${expandedImperatives[id] ? ' expanded' : ''}`}
      >
        <div className="imperative-name">{name}</div>
        <div className="imperative-score">{imperativeTasksComplete}/5</div>

        <div
          className="imperative-details"
          onClick={(e) => { e.stopPropagation(); return false; }}
        >
          <div className="imperative-summary">
            <h6>Quick summary</h6>
            <textarea
              onKeyDown={e => { this.handleQuickSummaryKeyDown(e, id); } }
              className="summary-text fs-block"
              placeholder={summaryQuestion}
              value={summary}
              onChange={(e) => { this.updateLocalImperativeSummary(id, e.target.value); }}
            ></textarea>
          {this.imperativeSummaryIsDirty(id) &&
            <div className="update-summary-action">
              <span className="save-shortcut-explanation">(SHIFT + &crarr;)</span>
                <button
                  disabled={this.state.syncingImperativeSummary === id}
                  onClick={() => { this.saveImperativeSummaryChanges(id); }}
                  className="button primary button-micro">
                  {this.state.syncingImperativeSummary !== id &&
                    <span>SAVE</span>
                  }
                  {this.state.syncingImperativeSummary === id &&
                    <span>SAVING...</span>
                  }
                </button>
            </div>
          }
          </div>
          <div className="imperative-items">
            <h6>Checklist</h6>
            {_.map(tasks, this.renderImperativeTask.bind(this))}
          </div>
          <div className="imperative-resources">
            <h6>Resources</h6>
            <div
              onClick={() => { this.viewDiscoveryQuestions(imperative); }}
              className="resource">
              {getIcon('questions')}
              <div className="resource-name">Discovery questions</div>
            </div>
            {isDevelopment() &&
              <div className="resource">
                {getIcon('questions')}
                <div className="resource-name">Common objections</div>
              </div>
            }
            {isDevelopment() &&
              <div className="resource">
                {getIcon('edit')}
                <div className="resource-name">Notes</div>
              </div>
            }
          </div>
        </div>
        <div className="toggle-expand-arrow">{getIcon('chevron-down')}</div>
      </div>
    );
  }

  renderImperativesSummary(){
    const imperatives = getSevenImperatives();

    return(
      <div className="imperatives-summary">
        <h2>Seven Imperatives</h2>

        <div className="imperatives-list">
          {_.map(imperatives, this.renderImperative.bind(this))}
        </div>
      </div>
    );
  }

  getStageStatus(stageId){

    const stages = getImperativesStages();
    const stageObjectives = this.getObjectivesForStage(stageId);
    const stageReciprocations = this.getReciprocationsForStage(stageId);

    let stageIsComplete = true;
    let stageIsStarted = false;

    _.each(_.union(stageObjectives, stageReciprocations), funnelTask => {
      if(this.getFunnelTaskStatus(funnelTask) && this.getFunnelTaskStatus(funnelTask) !== 'incomplete'){
        stageIsStarted = true;
      }
      if(this.getFunnelTaskStatus(funnelTask) !== 'complete'){
        stageIsComplete = false;
      }
    });

    if(stageIsComplete){
      return 'complete';
    }
    else if(stageIsStarted){
      return 'in_progress';
    }
    else{
      return 'not_started';
    }
  }

  renderFunnelTask(funnelTask){

    const { id, stage, imerativeItem, imperative, text} = funnelTask;

    const itemStatus = this.getFunnelTaskStatus(funnelTask);

    const isComplete = itemStatus === 'complete';
    const isFail = itemStatus === 'failed';
    const isIncomplete = itemStatus === 'incomplete';

    return(
      <div
        onClick={(e) => { e.stopPropagation(); this.trackFunnelTask(funnelTask); return false; }}
        key={id}
        className={`stage-item stage-item-${id} ${itemStatus}`}
      >
      <div
        onClick={(e) => { if(isIncomplete){ e.stopPropagation(); this.quickCompleteFunnelTask(funnelTask); return false; }}}
        className="stage-item-check">{isComplete ? getIcon('check-fill') : (isFail ? getIcon('check-fail') : getIcon('check-empty'))}</div>
        <div className="stage-item-text">{text}</div>
      </div>
    )
  }

  getObjectivesForStage(stageId){
    const allObjectives = getImperativesStages().objectives;

    const { customDealStageMappingEnabled, customDealStageMapping } = this.props.organization || {};

    if(customDealStageMappingEnabled && customDealStageMapping){
      return _.filter(allObjectives, objective => {
        return customDealStageMapping[objective.id] === stageId;
      }) || [];
    }
    else{
      return _.filter(allObjectives, { 'stage': stageId });
    }
  }

  getReciprocationsForStage(stageId){
    const allReciprocations = getImperativesStages().reciprocations;

    const { customDealStageMappingEnabled, customDealStageMapping } = this.props.organization || {};

    if(customDealStageMappingEnabled && customDealStageMapping){
      return _.filter(allReciprocations, reciprocation => {
        return customDealStageMapping[reciprocation.id] === stageId;
      }) || [];
    }
    else{
      return _.filter(allReciprocations, { 'stage': stageId });
    }
  }

  renderStage(stage, stageIndex){
    // console.log('rendering stage: ', stage);

    const { expandedStages } = this.state;

    const { label, value } = stage;

    const stageObjectives = this.getObjectivesForStage(value);
    const stageReciprocations = this.getReciprocationsForStage(value);

    // console.log('stageObjectives: ', stageObjectives);
    // console.log('stageReciprocations: ', stageReciprocations);

    const stageTotal = stageObjectives.length + stageReciprocations.length;

    const stageIsExpanded = !!expandedStages[value];
    const stageIsCurrent = (this.props.deal || {}).stage === value;

    //don't render stages w/o any items
    if(stageTotal === 0){
      return null;
    }

    // console.log('stageIndex: ', stageIndex);
    // console.log('this.dealStages().length: ', this.dealStages().length);

    const stageCompleteCount = _.reduce(_.union(stageObjectives, stageReciprocations), (memo, task) => {
      return memo + (this.getFunnelTaskStatus(task) === 'complete' ? 1 : 0);
    }, 0);

    let stageComplete = this.getStageStatus(value) === 'complete';

    return (
      <div
        key={value}
        className={`stage ${stageIsExpanded ? 'expanded' : ''} ${stageIsCurrent ? 'current' : ''}`}
      >
        <div className="stage-name">{label} ({stageCompleteCount}/{stageTotal})</div>
        <div
          onClick={() => { this.expandStage(value); }}
          className={`click-to-expand ${stageComplete ? ' complete' : ''}`}>{stageComplete && getIcon('check-fill')}{stageComplete ? 'Stage complete. Click to show details...' : 'Stage not yet started. Click to show details...'}</div>
        <div className="stage-item-group">
          <h6>Objectives</h6>
          {_.map(stageObjectives, this.renderFunnelTask.bind(this))}
        </div>
        <div className="stage-item-group">
          <h6>Reciprocations</h6>
          {_.map(stageReciprocations, this.renderFunnelTask.bind(this))}
        </div>

        {(stageIndex < this.dealStages().length - 1) &&
          <div className="arrow-to-next-stage">{getIcon('chevron-down')}</div>
        }
        {(stageIndex === this.dealStages().length - 1) && this.renderWonDealLink()}
      </div>
    );
  }

  renderWonDealLink(){
    const { deal } = this.props;

    if(!deal || deal.status === 'won'){ return null; }

    return <div
      onClick={this.beginUpdatingDeal.bind(this)}
      className="deal-won-prompt">Won this deal?</div>;
  }

  dealStages(){
    const stages = getImperativesStages().stages;
    const { customDealStageMappingEnabled, dealStages } = this.props.organization || {};

    if(customDealStageMappingEnabled && dealStages){
      return _.filter(dealStages, stage => { return stage.value !== 'Closed Won' && stage.value !== 'Closed Lost' });
    }
    else{
      return stages;
    }
  }

  renderBuyingStage(){

    const stages = this.dealStages();

    return(
      <div className="buying-stage">
        <h2>Objectives & Reciprocations</h2>
        <div className="stages">
          {_.map(stages, this.renderStage.bind(this))}
        </div>
      </div>
    );
  }

  renderDealDuration({status, createdOn, estimatedCloseDate}){
    if(!status || !createdOn){
      return null;
    }
    const daysOpen = moment().diff(createdOn.toDate(), 'days');
    const closedIn = moment(estimatedCloseDate).diff(createdOn.toDate(), 'days');

    const durationText = status === 'open' ? `Open for: ${daysOpen} day${daysOpen > 1 || daysOpen === 0 ? 's' : ''}` : (status === 'won' ? `Time to close: ${closedIn} day${closedIn > 1 || closedIn === 0 ? 's' : ''}` : false);

    if(status === 'open'){
      return (
        <p>{durationText}</p>
      )
    }
    else if(status === 'won'){
      return (
        <p>{durationText}</p>
      )
    }
    else{
      return null;
    }
  }

  renderDealSource(source){
    return (
      <div className="source salesforce">{getIcon('salesforce')}</div>
    );
  }

  accountName(accountId){
    const matchingAccount = _.find(this.props.accounts, { id: accountId });

    return matchingAccount ? matchingAccount.name : null;
  }

  renderDealInfo(){

    const { loadingDeal, deal } = this.props;

    if(loadingDeal || !deal){
      return null;
    }

    const { _id, name, estimatedCloseDate, product, products, createdOn, lastUpdated, source, stage, lastSynced, sf, nextStep, _deleted, deletedOn } = deal;

    const dealAccount = sf && sf.accountId && this.accountName(sf.accountId);
    const dealType = sf && sf.type;

    return (
      <div className="deal-info">
        {_deleted &&
          <h6 className="color-danger" style={{marginTop: 0, marginBottom: 0}}>Deleted {moment(deletedOn.toDate()).fromNow()}</h6>
        }
        <h1 className="fs-block">{name}{source && this.renderDealSource(source)}</h1>
        <h3 className="fs-block">Est Deal Size: {dealAmountAsString(deal)}<CurrencyTip deal={deal} /></h3>
        {product && product !== '' &&
          <p className="fs-block">Solution/Product: {product}</p>
        }
        {dealAccount &&
          <p className="fs-block">Account: {dealAccount}</p>
        }
        {dealType &&
          <p className="fs-block">Type: {dealType}</p>
        }
        {products &&
          <p className="fs-block">Products: {_.map(products, 'name').join(', ')}</p>
        }
        {nextStep &&
          <p>Next Step: {nextStep}</p>
        }
        {source === 'salesforce' &&
          <p>Stage: {stage}</p>
        }
        {createdOn &&
          <p>Created on: {moment(createdOn.toDate()).format('MM/DD/YYYY')}</p>
        }
        {this.renderDealDuration(deal)}
        {lastUpdated &&
          <p>Last updated: {moment(lastUpdated.toDate()).format('MM/DD/YYYY')}</p>
        }
        <div className="p fs-block">Est close date: <DealCloseDate deal={deal} /></div>
        <div className="actions">
          <p onClick={this.beginUpdatingDeal.bind(this)} className="edit">Edit Details</p>
          <DealSourceLink deal={deal} />
          <LinkDealToSource deal={deal} beginLinkingDeal={this.beginLinkingDeal.bind(this)} />
        </div>
        {lastSynced && lastSynced.toDate &&
          <div onClick={this.syncSalesforceDeal.bind(this)} className="last-synced">{this.state.syncingDeal ? 'Syncing...' : `Last synced ${moment(lastSynced.toDate()).fromNow()}`}</div>
        }
      </div>
    );
  }

  syncSalesforceDeal(){

    if(this.state.syncingDeal){
      return;
    }

    this.setState({
      syncingDeal: true,
    });

    syncSalesforceDeal(this.props.deal._id, resp => {
      if(resp && resp.success){
        this.props.fetchDeal(this.props.deal._id, this.mapDealToState.bind(this));
      }
      else{
        this.setState({
          syncingDeal: false,
          pageMessage: {
            messageContent: "Error syncing with Salesforce",
            messageType: 'error'
          }
        });
      }
    });
  }

  renderDealStatus(){
    const { loadingDeal, deal } = this.props;

    if(loadingDeal || !deal){
      return null;
    }

    const { status, stage } = deal;

    const statusLabel = status === 'open' && stage ? stage.toUpperCase() : status.toUpperCase();

    return (
      <div
        onClick={this.beginUpdatingDeal.bind(this)}
        className={`deal-status-label ${status}`}>
        <span className="current-status">{statusLabel}</span>
      </div>
    );
  }

  renderDealConfidence(){

    const dealCompletion = getDealCompletion(this.props.deal);

    if(!this.props.deal){
      return null;
    }

    if(!dealCompletion){ return null; }

    const { fractionComplete, percentComplete, confidence } = dealCompletion;

    return (
      <div className="deal-confidence">
        <div className="amount">{confidence}%</div>
        <div className="progress-bar">
          <div className={`progress ${getClassModifierForConfidence(confidence)}`} style={{width: `${confidence}%`}}></div>
        </div>
        <div className="label" data-for="deal-confidence-definition-tooltip" data-tip="Deal confidence helps gauge how far along deals are compared to one another and does not represent a precise probability to close">{getIcon('info-bold')} Deal Confidence</div>
        <div className="items-complete">Items Completed: {percentComplete}%</div>
        {moment(this.props.deal.createdOn.toDate()).diff(moment('09/30/2019')) > 0 &&
          <div onClick={() => { this.setState({ viewingDealActivity: true }) }} className="view-history">{getIcon('history-sheet')}<span>View Activity</span></div>
        }
        <ReactTooltip id="deal-confidence-definition-tooltip" effect="solid" place="top" />
      </div>
    );
  }

  renderKeyRisks(){

    const { keyRisks } = this.props.deal;

    return (
      <div className="key-risks">
        <h2>Key Risks</h2>
          <KeyRisks
            deal={this.props.deal}
            keyRisks={keyRisks}
            updateDeal={this.props.updateDeal}
          />
      </div>
    );
  }

  markActionItemAsNextStep(item){
    if(this.checkItemIsCurrentNextStep(item)){
      //already next step..do nothing
      return;
    }
    else{
      //update deal next step
      this.props.updateDeal({
        ...this.props.deal,
        nextStep: item.text,
      }, updatedDeal => {
        //done saving!
      });
    }
  }

  checkItemIsCurrentNextStep(item){
    return item.text === this.props.deal.nextStep;
  }

  renderActionItems(){

    const { savingDeal, organization } = this.props;
    const { actionItems } = this.props.deal;

    let showMarkAsNextStepSecondaryAction = false;

    if(!savingDeal && organization && organization.integrationNextStepEditingEnabled && ((organization.integrations || {}).salesforce || {}).status === 'live'){
      showMarkAsNextStepSecondaryAction = true;
    }

    return (
      <div className="key-risks">
        <h2>Action Items</h2>
          <ActionItems
            deal={this.props.deal}
            actionItems={actionItems}
            updateDeal={this.props.updateDeal}
            secondaryAction={showMarkAsNextStepSecondaryAction && {
              icon: 'plus-circle',
              action: this.markActionItemAsNextStep.bind(this),
              isDone: this.checkItemIsCurrentNextStep.bind(this),
              showIfDone: false,
              tooltip: "Mark as Next Step",
              doneTooltip: "Current Next Step",
              doneClass: "current"
            }}
          />
      </div>
    );
  }

  afterDealUpdate(){
    this.setState({
      updatingDeal: null,
      verifyingDeal: false,
    });
  }

  beginUpdatingDeal(){
    this.setState({
      updatingDeal: { ...this.props.deal }
    });
  }

  beginVerifyingDeal(){
    this.setState({
      updatingDeal: { ...this.props.deal },
      verifyingDeal: true
    });
  }

  renderPageLeftSection(){
    return(
      <div className="page-section-left">
        {this.renderKeyRisks()}
        {this.renderActionItems()}
        {this.renderImperativesSummary()}
      </div>
    )
  }
  renderPageRightSection(){
    return(
      <div className="page-section-right">
        {this.renderBuyingStage()}
      </div>
    )
  }

  renderDiscoveryQuestionsModal(){
    const { viewingImperativeDiscoveryQuestions } = this.state;

    if(!viewingImperativeDiscoveryQuestions){
      return null;
    }

    const questionsAsList = _.reduce(viewingImperativeDiscoveryQuestions.questions, (memo, question) => {
      return memo + `<li>${question.text}</li>`;
    }, '')
    const messageHtml = `
      <h2 style="margin-top:0px;">${viewingImperativeDiscoveryQuestions.name}</h2>
      <ul class="default-style-list large-items">${questionsAsList}</ul>
    `;

    return(
      <MessageModal
        visible={viewingImperativeDiscoveryQuestions}
        iconKey={'questions'}
        messageHtml={messageHtml}
        hide={() => { this.setState({ viewingImperativeDiscoveryQuestions: null }); }}
      />
    )
  }

  render(){

    const { redirectingToDeal, employeeId } = this.state;

    if(redirectingToDeal && document.location){
      const redirectToUrl = `${this.state.isOwnDeals ? `` : `/people/${employeeId}`}/imperatives/${redirectingToDeal}`;
      return <Redirect to={redirectToUrl} />
    }

    const loading = !this.props.user || this.props.loadingDeal | !this.props.deal;

    const closeStatusProgressNeedsVerification = this.props.deal && (this.props.deal.status === 'won' || this.props.deal.status === 'lost') && !this.props.deal.closeStatusProgressVerified;

    return (
      <Page
        pageClass="imperatives"
        loading={loading}
        pageMessage={this.state.pageMessage}
        clearMessage={() => { this.setState({ pageMessage: null }) }}
      >

        {closeStatusProgressNeedsVerification &&
          <div className="page-content">
            <div className="page-section bottom-border">
              <h2>Verify win progress...</h2>
              <p>This deal has been marked closed, but progress has not been verified.</p>
              <button
                onClick={() => { this.beginVerifyingDeal(); }}
                className="button primary button-tiny">Verify Deal Progress Now...</button>
            </div>
          </div>
        }

        {this.renderDealInfo()}
        {this.renderDealConfidence()}
        {this.renderDealStatus()}

        <div className="page-content">
          <div className="page-section top-border">
            {!loading && this.renderPageLeftSection()}
            {!loading && this.renderPageRightSection()}
          </div>
        </div>

        {this.renderTrackImperativeTaskModal()}
        {this.renderTrackFunnelTaskModal()}
        {this.renderDiscoveryQuestionsModal()}

        <LinkSalesforceDealModal
          hide={() => { this.setState({ linkingDeal: null }); }}
          linkingDealId={(this.props.deal || {})._id}
          visible={!!this.state.linkingDeal}
          afterLink={this.afterDealLink.bind(this)}
          deals={this.props.deals}
        />

        <UpdateDealModal
          hide={() => { this.setState({ updatingDeal: null, verifyingDeal: false }) }}
          editingDeal={this.state.updatingDeal}
          skipToVerify={this.state.verifyingDeal}
          visible={!!this.state.updatingDeal}
          onUpdate={this.afterDealUpdate.bind(this)}
          onReassign={deal => { /*hard reload page - too difficult to get this page state to reset otherwise*/ document.location=`/people/${deal.userId}/imperatives/${deal._id}`; } }
          onDelete={deal => { /*go to imperatives "home" for this person, since this deal no longer exists*/ document.location=`/people/${deal.userId}/imperatives`; }}
        />

        <DealActivityModal
          deal={this.props.deal}
          visible={this.state.viewingDealActivity}
          hide={() => { this.setState({ viewingDealActivity: false }); }}
        />
      </Page>
    )
  }
}

function mapStateToProps(state){
  return {
    user: state.user,
    deal: state.deal.data,
    deals: state.deals.data,
    loadingDeal: state.deal.loading,
    savingDeal: state.deal.saving,
    organization: state.organization.data,
    accounts: state.accounts.data
  }
}

export default connect(mapStateToProps, { fetchDeal, fetchDealsForEmployee, updateDeal })(ImperativesDealPage);



// WEBPACK FOOTER //
// ./src/components/imperatives/deal/index.js